import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, VStack, Flex, Text, Heading, Card } from '@tq/ui-components';

import { PastResponse } from 'types';
import { useFormatLocaleDate } from '../../../../config';

export const ResponseMobileCard: React.FC<
  Pick<PastResponse, 'id' | 'type' | 'response' | 'responseDate'>
> = ({ type, response, responseDate }) => {
  const { t } = useTranslation('consultation_response');
  const formatLocaleDate = useFormatLocaleDate();
  return (
    <VStack
      key={type + Math.random().toString(16).slice(2)}
      as={Card}
      spacing={5}
      width='100%'
      alignItems='flex-start'
      px={5}
      pt={8}
      pb={5}
    >
      <Flex width='100%'>
        <Box>
          <Heading size='xxs' as='h3'>
            {t('response_type', 'Response type')}
          </Heading>
          <Text>{type}</Text>
        </Box>
        <Button variant='secondary' size='xs' ml='auto'>
          {t('view_response', 'View response')}
        </Button>
      </Flex>
      <Box>
        <Heading size='xxs' as='h3'>
          {t('summary', 'Summary')}
        </Heading>
        <Text>{response}</Text>
      </Box>
      <Box>
        <Heading size='xxs' as='h3'>
          {t('response_date', 'Response date')}
        </Heading>
        <Text>{formatLocaleDate(responseDate)}</Text>
      </Box>
    </VStack>
  );
};
